import { ExternalUrl } from '@se/models';
import { ButtonsTypes } from 'estensa-module';

import { ToolbarAction } from './types';

export interface FormattedButtonResult {
    isValid: boolean;
    text: string;
}

export type ButtonFormattingParamKeys = 'EXT_USER_EXT' | 'EXT_PATIENTID_EXT' | 'EXT_OTHERPATIENTID_EXT' | 'EXT_TOKEN_EXT';

export type ButtonFormattingParams = Map<ButtonFormattingParamKeys, string | null>;

export function tryFormatButton(text: string, params: ButtonFormattingParams): FormattedButtonResult {
    let isValid = true;

    for (const [param, replacement] of params) {
        const regexp = new RegExp(param, 'g');
        if (!text.match(regexp)) {
            continue;
        }
        if (!replacement) {
            isValid = false;
            continue;
        }

        text = text.replace(regexp, replacement);
    }

    return {
        isValid,
        text,
    };
}

export function externalUrlToButton(item: ExternalUrl) {
    return {
        actionType: ToolbarAction.EXTERNAL_LINKS,
        label: item.description,
        isToggle: false,
        permission: ButtonsTypes.externalLinks,
        status: {
            visible: true,
            disabled: false,
        },
        payload: item.url,
        idCardioWebServiceForExtUrlToken: item.idCardioWebServiceForExtUrlToken || ''
    };
}

// export function smCertificateUrlToButton(item: SmCertificate) {
//     return {
//         actionType: ToolbarAction.PRINT_CERTIFICATE,
//         label: item.description,
//         isToggle: false,
//         permission: ButtonsTypes.printCertificate,
//         status: {
//             visible: true,
//             disabled: false,
//         },
//         payload: item.code
//     };
// }
